// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KMebz","col":"styles_col__8K9BG"};